import IObservation, { IObservationListSearch, IObservationCounters } from '../../interfaces/IObservation';
import { IObservationListState, IObservationFilters } from '../reducers/observationListReducer';

export const requestObservationList = "REQUEST_FETCH_OBSERVATION_LIST";
const successFetchObservationList = "SUCCESS_FETCH_OBSERVATION_LIST";
const failureFetchObservationList = "FAILURE_FETCH_OBSERVATION_LIST";

export const requestObservationListPage = "REQUEST_FETCH_OBSERVATION_LIST_PAGE";
const successObservationListPage = "SUCCESS_FETCH_OBSERVATION_LIST_PAGE";
const failureObservationListPage = "FAILURE_FETCH_OBSERVATION_LIST_PAGE";

const updateObservationListFilters = "UPDATE_OBSERVATION_LIST_FILTERS";

const setObservationPaginationPage = "SET_OBSERVATION_PAGINATION_PAGE";
const setObservationPaginationPageSize = "SET_OBSERVATION_PAGINATION_PAGE_SIZE";
const setObservationPaginationItemsCount = "SET_OBSERVATION_PAGINATION_ITEMS_COUNT";

export const requestObservationCounts = "REQUEST_FETCH_OBSERVATION_COUNTS";
const successFetchObservationCounts = "SUCCESS_FETCH_OBSERVATION_COUNTS";
const failureFetchObservationCounts = "FAILURE_FETCH_OBSERVATION_COUNTS";


export const setPageSize = "SET_PAGE_SIZE";

export interface ISetPageSize {
    type: typeof setPageSize;
    payload: { size: number }
}

export const createSetPageSizeAction = (size: number): ISetPageSize => ({
    type: setPageSize,
    payload: { size }
});


// FETCH OBSERVATION
export interface IRequestFetchObservationList {
    type: typeof requestObservationList;
    payload: { search?: IObservationFilters }
}

interface ISuccessFetchObservationList {
    type: typeof successFetchObservationList;
    payload: { observations: IObservation[] };
}

interface IFailureFetchObservationList {
    type: typeof failureFetchObservationList;
    payload: { error: Error };
}

export interface IRequestFetchObservationListPage {
    type: typeof requestObservationListPage;
}

interface ISuccessFetchObservationListPage {
    type: typeof successObservationListPage;
    payload: { observations: IObservation[] };
}

interface IFailureFetchObservationListPage {
    type: typeof failureObservationListPage;
    paylod: { error: Error };
}

// PAGINATED LIST UPDATES

interface IUpdateObservationListFilters {
    type: typeof updateObservationListFilters;
    payload: {
        filters: Partial<IObservationListState["filters"]>;
    };
}

interface ISetObservationPaginationPage {
    type: typeof setObservationPaginationPage;
    payload: { page: number },
}

interface ISetObservationPaginationPageSize {
    type: typeof setObservationPaginationPageSize;
    payload: { pageSize: number }
}

interface ISetObservationPaginationItemsCount {
    type: typeof setObservationPaginationItemsCount;
    payload: { count: number };
}

// FETCH COUNTERS
export interface IRequestFetchObservationCounts {
    type: typeof requestObservationCounts;
    payload: { search?: IObservationFilters }
}

interface ISuccessFetchObservationCounts {
    type: typeof successFetchObservationCounts;
    payload: { counters: IObservationCounters };
}

interface IFailureFetchObservationCounts {
    type: typeof failureFetchObservationCounts;
    payload: { error: Error };
}

export type IObservationListAction
    = IRequestFetchObservationList
    | ISuccessFetchObservationList
    | IFailureFetchObservationList

    | IUpdateObservationListFilters
    | ISetObservationPaginationPage
    | ISetObservationPaginationPageSize
    | ISetObservationPaginationItemsCount

    | IRequestFetchObservationListPage
    | ISuccessFetchObservationListPage
    | IFailureFetchObservationListPage

    | IRequestFetchObservationCounts
    | ISuccessFetchObservationCounts
    | IFailureFetchObservationCounts

    | ISetPageSize
    ;

// FETCH OBSERVATION
export const createRequestFetchObservationListAction = (search?: IObservationFilters): IRequestFetchObservationList => ({
    type: requestObservationList,
    payload: { search }
});

export const createSuccessFetchObservationListAction = (observations: IObservation[]): ISuccessFetchObservationList => ({
    type: successFetchObservationList,
    payload: { observations }
});

export const createFailureFetchObservationListAction = (error: Error): IFailureFetchObservationList => ({
    type: failureFetchObservationList,
    payload: { error }
});

export const createRequestFetchObservationPageAction = (): IRequestFetchObservationListPage => ({
    type: requestObservationListPage,
});

export const createSuccessFetchObservationListPageAction = (observations: IObservation[]): ISuccessFetchObservationListPage => ({
    type: successObservationListPage,
    payload: { observations },
});

export const createFailureFetchObservationListPageAction = (error: Error): IFailureFetchObservationListPage => ({
    type: failureObservationListPage,
    paylod: { error },
});

// PAGINATED LIST FILTER UPDATES

export const createUpdateObservationFilters = (updatedFilters: Partial<IObservationListState["filters"]>): IUpdateObservationListFilters => ({
    type: updateObservationListFilters,
    payload: { filters: updatedFilters },
});

export const createSetObservationPaginationPageAction = (page: number): ISetObservationPaginationPage => ({
    type: setObservationPaginationPage,
    payload: { page },
});

export const createSetObservationPaginationPageSizeAction = (pageSize: number): ISetObservationPaginationPageSize => ({
    type: setObservationPaginationPageSize,
    payload: { pageSize },
});

export const createSetObservationPaginationItemsCountAction = (count: number): ISetObservationPaginationItemsCount => ({
    type: setObservationPaginationItemsCount,
    payload: { count },
});

// FETCH COUNTERS
export const createRequestFetchObservationCountsAction = (search?: IObservationFilters): IRequestFetchObservationCounts => ({
    type: requestObservationCounts,
    payload: { search }
});

export const createSuccessFetchObservationCountsAction = (counters: IObservationCounters): ISuccessFetchObservationCounts => ({
    type: successFetchObservationCounts,
    payload: { counters }
});

export const createFailureFetchObservationCountsAction = (error: Error): IFailureFetchObservationCounts => ({
    type: failureFetchObservationCounts,
    payload: { error }
});


